import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import InnerHeader from "./InnerHeader";
import CounterSec from "./CounterSec";
import ContactSec from "./ContactSec";
import ImageSlider from "./ImageSlider";

const About = () => {
  const CounterData = [
    {
      count: "12+",
      text: "Countries Served",
    },
    {
      count: "99.9%",
      text: "System Uptime",
    },
    {
      count: "50k",
      text: "Registered Users",
    },
    {
      count: "4.9",
      text: "Average Rating",
    },
  ];
  return (
    <div className="about-page">
      <InnerHeader heading="About Us" />
      <CounterSec counterData={CounterData} />
      <section className="about-sec">
        <div className="container">
          <div className="row row-gap-25 align-items-center">
            <div className="col-lg-6 col-12">
              <img className="w-100 h-auto" src="/about.png" alt="about-img" />
            </div>
            <div className="col-lg-6 col-12">
              <div className="ab-con">
                <h2 className="sec-head xsm has-red-bg">About us</h2>
                <h3 className="sec-head">video vision media</h3>
                <p className="para">
                  Video Vision Media is a next-generation media technology and
                  satellite services company. We empower broadcasters, telecom
                  operators, enterprises, and governments to connect, create,
                  and deliver content seamlessly anytime, anywhere, on any
                  platform. From our hubs in the UK, UAE, India and Singapore,
                  we bring together satellite, cloud, and IP networks with
                  creative post-production services, studio and playout
                  services, giving our clients end-to-end solutions that are
                  reliable, innovative, and scalable.
                </p>
                <h2 className="sec-head xsm mt-3">Our Mission</h2>
                <p className="para">
                  Our mission is to provide seamless, secure, and innovative
                  media and connectivity solutions that empower clients to
                  communicate, engage, and operate with confidence — anywhere in
                  the world.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="who-sec">
        <img src="/cov-bg.png" alt="who-bg" className="who-bg" />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-12">
              <h2 className="sec-head white">Our Coverage Area</h2>
              <ul className="srv-dist-card-list like-para white">
                <li>
                  <strong>UAE</strong> – Media distribution, satellite teleport,
                  creative &amp; playout hub.
                </li>
                <li>
                  <strong>UK</strong> – Broadcast operations, media telecom
                  integration, and pan-European support.
                </li>
                <li>
                  <strong>Worldwide</strong> – Partner teleports, fiber/IP
                  nodes, and cloud integration across major regions.
                </li>
              </ul>
            </div>
            <div className="col-12">
              <ImageSlider />
            </div>
          </div>
        </div>
      </section>
      <ContactSec />
    </div>
  );
};

export default About;
